"use client";

import React, { useState } from "react";
import { Col } from "react-bootstrap";
import { useField } from "formik";
import { humanize } from "@/app/components/util";

const Password = ({
  name,
  label,
  noLabel = false,
  required = false,
  col = 6,
  className = "",
  placeholder = "",
  id,
}) => {
  const [field, meta] = useField(name);
  const [showPassword, setShowPassword] = useState(false);
  const inputId = id || name;

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const hasError = meta.touched && meta.error;

  return (
    <Col xs={col}>
      {!noLabel && (
        <label htmlFor={inputId} className="form-label m-0 fw-500">
          {label || humanize(name)}
          {required && <span className="text-danger"> *</span>}
        </label>
      )}

      <div className="input-group input-group-suffix mb-1">
        <input
          {...field}
          id={inputId}
          type={showPassword ? "text" : "password"}
          className={`form-control ${className} ${hasError ? "is-invalid" : ""}`}
          placeholder={placeholder}
          required={required}
        />
        <span
          className="input-group-text"
          style={{ cursor: "pointer" }}
          onClick={togglePasswordVisibility}
        >
          <i className={`bi ${showPassword ? "bi-eye" : "bi-eye-slash"}`} />
        </span>
      </div>

      <div
        className="invalid-feedback d-block"
        style={{ minHeight: "1.25rem" }}
      >
        {hasError ? meta.error : null}
      </div>
    </Col>
  );
};

export default Password;
